/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventunlisted1Inputs */

const en_eventunlisted1 = /** @type {(inputs: Eventunlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event unlisted`)
};

const de_eventunlisted1 = /** @type {(inputs: Eventunlisted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event nicht mehr öffentlich gelistet`)
};

/**
* | output |
* | --- |
* | "Event unlisted" |
*
* @param {Eventunlisted1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventunlisted1 = /** @type {((inputs?: Eventunlisted1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventunlisted1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventunlisted1(inputs)
	return de_eventunlisted1(inputs)
});
export { eventunlisted1 as "eventUnlisted" }